<template>
  <div>
    <el-select
        v-model="innerValue"
        size="small"
        :placeholder="$t('common.pleaseSelect')"
        v-on="$listeners"
        v-bind="$attrs"
    >
      <el-option
          v-for="item in options"
          :key="item.userId"
          :label="item.userName"
          :value="item.userId"
      />
    </el-select>
  </div>
</template>

<script>
export default {
  name: "ChildCode",
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    newStr: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      innerValue: this.value,
      options: []
    }
  },
  mounted() {
    this.codeList()
  },
  methods: {
    async codeList() {
      //获取信息列表
      const res = await this.$http.get(
          "/admin/subAccountList",
      );
      // console.log(res.data.data,'获取信息列表=====')
      // console.log(this.newStr,'获取信息列表=====')
      if(this.newStr){
        this.options = res.data.data.filter(item => {
          return item.userName !== this.newStr;
        })
      }else {
        this.options = res.data.data
      }
    },
  },
  watch: {
    // 父 → 子
    value(val) {
      this.innerValue = val
    },
    // 子 → 父
    innerValue(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style scoped lang="less">

</style>